import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function TallasCreate() {
  const { user } = useContext(AuthContext);
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_VARIANTES_TALLAS = process.env.REACT_APP_URL_VARIANTES_TALLAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [variante, setVariante] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const [variantesTallas, setVariantesTallas] = useState([]);

    useEffect(() => {
      axios
      .get(URL_VARIANTES_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVariantesTallas = response.data;
        setVariantesTallas(allVariantesTallas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const clear = () => {
    setName("");
  };

const saveTallas = (event) => {
  event.preventDefault();
  setValidaBoton(false);

  // Asegurar que sea arreglo o arreglo vacío
  const variantesArray = variante ? [variante] : [];

  axios
    .post(
      URL_TALLAS,
      {
        name,
        variantesTallas: variantesArray, // <- Enviar como arreglo
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    )
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "Crear Talla",
          detalle: name,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      clear();
      Swal.fire("Good job!", "Creado con éxito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
};


  return (
    <>
      <div className="container">
        <h3 align="center">Crea un Talla nuevo</h3>
        <Form onSubmit={saveTallas}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Row>
              <Label for="exampleEmail" className="mr-sm-2">
                Talla
              </Label>
              <Input
                type="text"
                name="email"
                id="exampleEmail"
                placeholder="Nombre del Talla"
                value={name}
                required
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Row>
            <Row>
              <Label for="exampleEmail" className="mr-sm-2">
                Variante
              </Label>
              <Input
                className="col-sm-12"
                type="select"
                value={variante}
                required
                onChange={(e) => {
                  setVariante(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {variantesTallas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Row>
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/MenuCatalogos">
              Regresar
            </Button>
          </Row>
        </Form>
      </div>
    </>
  );
}

export default TallasCreate;
